import { notification } from "antd";
import api from "./api-base";
import { useMutation, useQuery, useQueryClient } from "react-query";

//Auth API
const validateLogin = async (payload) => await api.post(`Users/authenticate`, payload);

//Auth Queries
export function useValidateLogin() {
    return useMutation(validateLogin);
}

//Product API
const getProducts = async () => await api.get(`/product`);

const getProductById = async (productId) => await api.get(`/product/${productId}`);

const addProduct = async (payload) => await api.post(`/product`, payload);

const editProduct = async ({ productId, payload }) => await api.put(`/product/${productId}`, payload);




//Register Business
const getBusiness = async () => await api.get(`/businesses`);
const addBusiness = async () => await api.post(`/businesses`);

//Business Queries
export function useGetBusiness() {
    return useQuery(['getBusiness'], getBusiness);
}
export function useAddBusiness() {
    return useQuery(['addBusiness'], addBusiness);
}

//Product Queries
export function useGetProducts() {
    return useQuery(['getProducts'], getProducts);
}

export function useGetProductById(productId) {
    return useQuery(['getProductById', productId], 
        () => getProductById(productId), {enabled: !!productId});
}

export function useAddProduct() {
    const queryClient = useQueryClient();

    return useMutation(addProduct, {
        onSuccess: () => {
            notification.success({ message: "Product saved successfully" });
            queryClient.invalidateQueries('getProducts');
        }
    });
}

export function useEditProduct() {
    const queryClient = useQueryClient();
  
    return useMutation(editProduct,{
        onSuccess:()=>{
            notification.success({ message: "Product updated successfully" });
            queryClient.invalidateQueries('getProducts');
        }
    });
}

//Company API
const getCompany = async () => await api.get(`/company`);

const getCompanyById = async (companyId) => await api.get(`/company/${companyId}`);
const addCompany = async (payload) => await api.post(`/company`, payload);

const editCompany = async ({ companyId, payload }) => await api.put(`/company/${companyId}`, payload);



export function useGetCompany() {
    return useQuery(['getCampany'], getCompany);
}

export function useAddCompany() {
    const queryClient = useQueryClient();
    return useMutation(addCompany, {
        onSuccess: () => {
            notification.success({ message: "Company saved successfully" });
            queryClient.invalidateQueries('getCompany');
        }
    });
}

export function useGetCompanyById(companyId) {
    return useQuery(['getCompanyById'],
        () => getCompanyById(companyId), { enabled: !!companyId });
}

export function useEditCompany() {
    const queryClient = useQueryClient();
    return useMutation(editCompany, {
        onSuccess: () => {
            notification.success({ message: "Company updted successfully" });
            queryClient.invalidateQueries('getCompany');
        }
    }
    );
}


//Role API
const getRole = async () => await api.get(`/roles`);

const getRoleById = async (roleId) => await api.get(`/roles/${roleId}`);

const addRole = async (payload) => await api.post(`/roles`, payload);

const editRole = async ({ roleId, payload }) => await api.put(`/roles/${roleId}`, payload);



export function useGetRole() {
    return useQuery(['getRole'], getRole);
}

export function useAddRole() {
    const queryClient = useQueryClient();
    return useMutation(addRole, {
        onSuccess: () => {
            notification.success({ message: "Role saved successfully" });
            queryClient.invalidateQueries('getRole');
        }
    });
}

export function useGetRoleById(roleId) {
    return useQuery(['getRoleById'],
        () => getRoleById(roleId), { enabled: !!roleId });
}

export function useEditRole() {
    const queryClient = useQueryClient();
    return useMutation(editRole, {
        onSuccess: () => {
            notification.success({ message: "Role updted successfully" });
            queryClient.invalidateQueries('getRole');
        }
    }
    );
}


//Users API
const getUser = async () => await api.get(`/user`);

const getUserById = async (userId) => await api.get(`/user/${userId}`);

const getUserByRoleId = async (roleId) => await api.get(`/user/role/${roleId}`);

const addUser = async (payload) => await api.post(`/user`, payload);

const editUser = async ({ userId, payload }) => await api.put(`/user/${userId}`, payload);



export function useGetUser() {
    return useQuery(['getUser'], getUser);
}

export function useAddUser() {
    const queryClient = useQueryClient();
    return useMutation(addUser, {
        onSuccess: () => {
            notification.success({ message: "User saved successfully" });
            queryClient.invalidateQueries('getUsers');
        }
    });
}

export function useGetUserById(userId) {
    return useQuery(['getUserById'],
        () => getUserById(userId), { enabled: !!userId });
}

export function useGetUserByRoleId(roleId) {
    return useQuery(['getUserByRoleId'],
        () => getUserByRoleId(roleId), { enabled: !!roleId });
}

export function useEditUser() {
    const queryClient = useQueryClient();
    return useMutation(editUser, {
        onSuccess: () => {
            notification.success({ message: "User updeted successfully" });
            queryClient.invalidateQueries('getUsers');
        }
    }
    );
}
